<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname" />
    </div>
    <div class="content" style="background: white">
      <Home
        v-if="page == 'home'"
        @changePage="changePage"
        @mtdBackCampus="mtdBackCampus"
      />
      <Recetas v-if="page == 'recetas'" @returnHome="returnHome" />
      <Rehabilitacion v-if="page == 'rehabilitation'" @returnHome="returnHome" />
    </div>
    <div class="footer">
      <FooterVue @changePage="changePage" :pageView="page" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Nav from "../../components/Servicios/Nav.vue";
import FooterVue from "../../components/Servicios/Footer.vue";
import Home from "../../components/Servicios/Home.vue";
import Recetas from "../../components/Servicios/pages/Recipes.vue";
import Rehabilitacion from "../../components/Servicios/pages/Rehabilitacion.vue";

export default {
  name: "ServiciosView",
  components: {
    Nav,
    FooterVue,
    Home,
    Recetas,
    Rehabilitacion
  },
  data() {
    return {
      prefix: "Pharmacy",
      area: "Servicios",
      bead: {},
      verifBead: false,
      boxes: [],
      page: "home",
      client: null,
    };
  },
  props: {
    rolname: String,
  },
  created() {
    this.rol_name = this.rolname;
    //this.mtdDataBead();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdDataBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/listBeads/" +
          this.$store.getters.get__campus,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.boxes = response.data.boxes;
          this.bead = response.data.bead;
          this.verifBead = response.data.bead != null ? true : false;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    changePageVen: function (page, client) {
      this.client = page == "venta" ? client : page == "home" ? this.client : null;
      this.page = page;
    },
    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdBackRol: function () {
      this.$emit("mtdBackRol");
    },
    mtdCommitPayment: function (res) {
      this.bead = res;
      this.page = "directa";
    },
    /** apertura */
    mtdOpen: function (data) {
      this.verifBead = true;
      this.page = "home";
      this.bead = data;
    },
  },
};
</script>
